import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, FormGroup, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom'; // useLocation
import { useTranslation } from 'react-i18next';
import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
import { cloneDeep, isEmpty } from 'lodash';
import noImage from '../../../../assets/images/no-image.png';
import ImgDropzone from '../../../../Components/ImgDropzone/ImgDropzone';
import BtnDelete from '../../../../Components/Utility/FilterAction/BtnDelete';
import * as action from '../Store/Testing.action';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { shortenStringWithTooltip } from '../../../../Components/helper';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';

const AsyncTypeahead = asyncContainer(Typeahead);

const middlevalues = (obj1, obj2) => {
  return obj1 ? `, ${obj2}` : `${obj2}`;
};

function AddEditTestingGroup() {
  const history = useHistory();
  const { id } = useParams();
  const paramId = id;
  const { t } = useTranslation('common');
  const typeaheadConfig = useRef(null);
  const testingGroupReduxData = useSelector((state) => state);
  const { UserDetails, TestDetails, BOMConfigDetails } = testingGroupReduxData;
  const { userInfo } = UserDetails;
  const { librayList, editData, addParamId, allOptions, selectedIds } = TestDetails;
  const { isSupplierLoggedIn } = UserDetails;
  const { isProductArchived } = BOMConfigDetails;
  const dispatch = useDispatch();
  const loggedinUserId = userInfo.userId;

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [allowEdit, setAllowEdit] = useState(false);
  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [croppedImage, setCroppedImage] = useState('');
  const childRef = useRef();
  const [isNewUploaded, setIsNewUploaded] = useState(true);
  const [showImageUpload, setImgUpload] = useState(false);
  const [suggestionLoader, setsuggestionLoader] = useState(false);
  const [isSelectAll, setSelectAll] = useState(false); // 1 set Select all false in delete
  const [colourRefData, setColourRefData] = useState([]);
  const [colourRefDatatoShow, setColourRefDatatoShow] = useState([]);
  const [addColour, setAddColour] = useState(false);
  const [addNewColours, setAddNewColours] = useState(false);
  const [removeImage, setRemoveImage] = useState(false);
  const [originalImage, setOriginalImage] = useState('');
  const [prevcroppedImage, setPreviouslyCroppedImage] = useState('');

  const removeImg = () => {
    setCroppedImage('');
    setOriginalImage('');
    setRemoveImage(true);
  };

  const handleImageUpload = async (type) => {
    if (type !== 'close') {
      const { imageRes, originalImg } = await childRef.current.showCroppedImg();
      if (imageRes === undefined) {
        toasterMsg(t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.PLEASE_UPLOAD_IMAGE'), 'danger');
      } else {
        const ogImage = await originalImg;
        setOriginalImage(ogImage);
        if (imageRes?.length > 0) setCroppedImage(imageRes);
        setIsNewUploaded(true);
        setRemoveImage(false);
        setImgUpload(false);
      }
    } else {
      setImgUpload(false);
    }
  };

  const initialExicution = async () => {
    if (paramId) {
      setAllowEdit(false);
      const getDetailparams = {
        groupId: paramId,
        loggedInUserId: loggedinUserId,
      };
      await dispatch(action.getDataForEdit(getDetailparams));
    }
    if (selectedIds && !isEmpty(selectedIds)) {
      await dispatch(action.getTestingLibrary({ loggedinUserId }));
    }
  };

  useEffect(() => {
    setColourRefData(librayList);
    return () => {
      setColourRefData([]);
    };
  }, [librayList]);

  useEffect(() => {
    if (paramId && editData && !isEmpty(editData)) {
      !isEmpty(editData.testingIds) && dispatch(action.getTestingLibrary({ loggedinUserId }));
      setValue('groupName', editData.name);
      setValue('groupDescription', editData.description);
      setCroppedImage(editData.image);
      setOriginalImage(editData.fullImage);
      setPreviouslyCroppedImage(editData.image);
      setIsNewUploaded(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData, paramId]);

  const setLibId = async () => {
    if (colourRefDatatoShow && !isEmpty(colourRefDatatoShow) && selectedIds && !isEmpty(selectedIds) && addColour) {
      setAddColour(false);
      const stopVar = [];
      const tempArray = colourRefDatatoShow;
      tempArray.forEach((forElement) => {
        if (selectedIds.includes(forElement._id)) {
          stopVar.push(forElement);
        }
      });
      if (stopVar && isEmpty(stopVar)) {
        if (colourRefData && !isEmpty(colourRefData)) {
          const foundData = colourRefData.filter((value) => selectedIds.includes(value._id));
          setColourRefDatatoShow([...foundData, ...colourRefDatatoShow]);
          setAllowEdit(true);
        }
      } else {
        toasterMsg(t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.TESTING_LIBRARY_ADDED'), 'danger');
      }
    }
  };

  useEffect(() => {
    setLibId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addColour, selectedIds, colourRefData]);

  useEffect(() => {
    if (selectedIds && !isEmpty(selectedIds) && addNewColours) {
      setAddNewColours(false);
      if (colourRefData && !isEmpty(colourRefData)) {
        const foundData = colourRefData.filter((value) => selectedIds.includes(value._id));
        setColourRefDatatoShow([...foundData]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIds, addNewColours, colourRefData]);

  useEffect(() => {
    if (editData?.testingIds && !isEmpty(editData.testingIds) && colourRefData && !isEmpty(colourRefData)) {
      const foundData = colourRefData.filter((value) => editData.testingIds.includes(value._id));
      setColourRefDatatoShow(foundData);
      setAddColour(true);
    }
    if (editData && isEmpty(editData) && selectedIds) {
      setAddNewColours(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colourRefData, editData]);

  useEffect(() => {
    initialExicution();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramId]);

  useEffect(() => {
    if (addParamId) {
      history.push(`/libraries/testing-group/edit/${addParamId}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addParamId]);

  const putImage = (paramName) => {
    if (croppedImage !== prevcroppedImage) {
      paramName.image = croppedImage !== noImage ? croppedImage : '';
      paramName.fullImage = originalImage;
    }
  };

  const onSubmitMethod = async (data) => {
    if (paramId) {
      setAllowEdit(false);
      const put_params = {
        description: data.groupDescription,
        groupId: paramId,
        loggedInUserId: loggedinUserId,
        name: data.groupName,
        testings: data.colourWays ? JSON.stringify(data.colourWays) : '[]',
        id: paramId,
      };
      if (croppedImage) {
        put_params.removeImage = removeImage;
        put_params.image = croppedImage !== noImage ? croppedImage : '';
        put_params.fullImage = originalImage;
      }
      await dispatch(action.updateTestingGroups(put_params, t));
      const notUpdateParams = {
        groupId: paramId,
        loggedInUserId: loggedinUserId,
      };
      await dispatch(action.getDataForEdit(notUpdateParams));
    } else {
      postData(data);
    }
    await dispatch(action.emptyReducer());
  };

  const postData = async (data) => {
    const post_params = {
      description: data.groupDescription,
      loggedInUserId: loggedinUserId,
      name: data.groupName,
      testings: data.colourWays ? JSON.stringify(data.colourWays) : '[]',
    };
    if (croppedImage) {
      putImage(post_params);
    }
    post_params.removeImage = removeImage;
    await dispatch(action.addNewTestGroups(post_params, t));
  };

  const onCancle = async () => {
    dispatch(action.emptyReducer());
    setColourRefDatatoShow([]);
    setAddNewColours(false);
    setAllowEdit(false);
    setAddColour(false);
    await dispatch(action.emptyReducer());
    history.push('/libraries/testing-group');
  };

  const handleDeleteCard = (deleteid) => {
    const selectedItems = cloneDeep(selectedIdArray);
    let coloursData = cloneDeep(colourRefDatatoShow);
    if (deleteid === null) {
      coloursData = coloursData.filter((item) => !selectedItems.includes(item._id));
      setSelectAll(false);
      setSelectedIdArray([]);
      setValue('colourWays', coloursData);
      setColourRefDatatoShow(coloursData);
    } else {
      setSelectAll(false);
      setSelectedIdArray([]);
      colourRefDatatoShow.splice(deleteid, 1);
      setValue('colourWays', colourRefDatatoShow);
      setColourRefDatatoShow([...colourRefDatatoShow]);
    }
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedIdArray([]);
    } else {
      const selectedItems = [...selectedIdArray];

      for (const item of colourRefDatatoShow) {
        const findItems = selectedItems.filter((val) => val === item._id);
        if (findItems.length === 0) {
          selectedItems.push(item._id);
        }
      }
      setSelectedIdArray(selectedItems);
    }
    setSelectAll(!isSelectAll);
  };

  const onSelectCheckBox = async (e, checkBoxid) => {
    let selectedItems = [...selectedIdArray];
    if (e.target.checked) {
      setSelectedIdArray([...selectedItems, checkBoxid]);
    } else {
      setSelectAll(false);
      selectedItems = selectedItems.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
    }
  };

  useEffect(() => {
    if (colourRefDatatoShow && colourRefDatatoShow.length !== 0) {
      setValue(
        'colourWays',
        colourRefDatatoShow.map((cwE) => cwE._id),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colourRefDatatoShow]);

  const onAutoSuggestion = async (selected) => {
    const typeaheadConfigRef = typeaheadConfig.current;

    const ifIncludes = colourRefDatatoShow.filter((ele) => ele._id === selected[0]._id && ele);
    if (ifIncludes && !isEmpty(ifIncludes)) {
      toasterMsg(t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.TESTING_LIBRARY'), 'danger');
    } else {
      setColourRefDatatoShow((colourRefDatatoSh) => [...colourRefDatatoSh, ...selected]);
    }
    if (typeaheadConfigRef) typeaheadConfigRef.clear();
  };

  const promiseSearch = async (inputValue) => {
    if (inputValue && inputValue.trim().length !== 0) {
      setsuggestionLoader((prev) => !prev);
      const searchParams = {
        loggedinUserId,
        searchText: inputValue,
        from: 'search',
      };
      await dispatch(action.getTestingLibrary(searchParams));
      setsuggestionLoader((prev) => !prev);
    }
  };

  const handleTable = (item, i) => {
    return (
      <tr key={i}>
        <td>
          <div className="checkbox-label no-label margin-auto">
            <input
              onChange={(e) => {
                onSelectCheckBox(e, item._id);
              }}
              name={`checks_${i}`}
              id={`checks_${i}`}
              type="checkbox"
              disabled={paramId && !allowEdit}
              checked={selectedIdArray.filter((val) => val === item._id).length > 0}
            />
            <label htmlFor={`checks_${i}`} className="chklabel">
              <span />
            </label>
          </div>
        </td>
        <td className="last-fix-col">
          <div>
            <span>{item?.code}</span>
          </div>
        </td>
        <td>
          <div>
            <span>{item?.description} </span>
          </div>
        </td>
        <td>
          <div>
            <span>{item?.type?.name} </span>
          </div>
        </td>
        <td>
          <div>
            <span>{item?.minPassRate} </span>
          </div>
        </td>
        <td>
          <div>
            <span>{item?.testReport?.pdfTitle}</span>
          </div>
        </td>
        <td>
          <div>
            <span>{item?.supplier?.name}</span>
          </div>
        </td>
        <td>
          <div>
            <span>{item?.bomComponent?.referenceCode}</span>
          </div>
        </td>
        <td>
          <div>
            <span>{item?.colour?.name}</span>
          </div>
        </td>
        <td>
          <div>
            <span>{item?.additionalInformation} </span>
          </div>
        </td>
        <td>
          <div>
            <span>{item?.testPrice} </span>
          </div>
        </td>
        <td>
          <div className="action-btns d-flex align-items-center">
            <button className="btn" onClick={() => handleDeleteCard(i)} disabled={paramId && !allowEdit}>
              <span className="icon-delete" />
            </button>
          </div>
        </td>
      </tr>
    );
  };

  const editbtn = () => {
    return (
      <button className="btn btn-white btn-back-lib" onClick={() => setAllowEdit(true)} type="button">
        {t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.EDIT')}
      </button>
    );
  };

  const savebtn = () => {
    return (
      <button className="btn btn-white btn-back-lib" onClick={handleSubmit(onSubmitMethod)} type="submit">
        <span className="icon-Save mr-2 " />
        {t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.SAVE')}
      </button>
    );
  };

  const backbtn = () => {
    return (
      <button className="btn btn-white btn-back-lib" onClick={onCancle} type="button">
        {t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.BACK')}
      </button>
    );
  };
  const canclebtn = () => {
    return (
      <button className="btn btn-white btn-back-lib" onClick={onCancle} type="button">
        {t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.CANCEL')}
      </button>
    );
  };

  const btns = () => {
    return paramId && !allowEdit ? editbtn() : otherBtns();
  };

  const otherBtns = () => {
    return paramId && allowEdit ? savebtn() : noParamIdBtn();
  };

  const noParamIdBtn = () => {
    return !paramId ? savebtn() : null;
  };

  const backOrCancle = () => {
    return paramId ? backbtn() : canclebtn();
  };

  const imageSource = () => croppedImage || noImage;

  const imgsrc = () => {
    return originalImage || croppedImage;
  };

  const buttons = () => {
    return (
      ((paramId && allowEdit) || !paramId) && (
        <>
          <button className="btn btn-upload-img" type="button" onClick={() => setImgUpload(true)}>
            <span className="icon-upload" aria-hidden="true" title={t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.UPLOAD_IMAGE')} />
          </button>

          <button
            className={classUsed()}
            type="button"
            disabled={croppedImage === null || !croppedImage || croppedImage === noImage}
            onClick={() => removeImg()}
          >
            <span className="icon-delete" aria-hidden="true" title={t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.REMOVE_IMAGE')} />
          </button>
        </>
      )
    );
  };

  const classUsed = () => {
    return croppedImage === noImage ? 'btn btn-upload-img disabled' : 'btn btn-upload-img';
  };

  const openSupps = (option) => {
    return option?.supplier && option?.supplier !== null ? option?.supplier?.name : '';
  };

  const openBom = (option) => {
    return option?.bomComponent && option?.bomComponent !== null ? middlevalues(option?.supplier?.name, option?.bomComponent?.referenceCode) : '';
  };
  const colourNames = (element) => {
    const compos = [];
    element?.forEach((ele) => {
      compos.push(ele?.name);
    });
    return compos.join(' , ');
  };

  const openCol = (option) => {
    if (Array.isArray(option.colour)) {
      return !isEmpty(option.colour) ? `, ${colourNames(option.colour)}` : '';
    }
    return option?.colour && option?.colour !== null ? middlevalues(option?.supplier?.name || option?.bomComponent?.referenceCode, option?.colour?.name) : '';
  };

  const openDesc = (option) => {
    return option.description ? `${option.description}` : '';
  };

  const openBracket = (option) => {
    return option?.supplier !== null || option?.bomComponent !== null || option.colour !== null ? ' (' : '';
  };
  const CloseBracket = (option) => {
    return option?.supplier !== null || option?.bomComponent !== null || option.colour !== null ? ' )' : '';
  };

  return (
    <>
      {showImageUpload ? (
        <Modal className="common-custom-modal modal-large" show={showImageUpload} backdrop="static">
          <Modal.Header>
            <Modal.Title className="f-24">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.UPLOAD_IMAGE')}</Modal.Title>
            <span onClick={() => handleImageUpload('close')} className="icon-close cursor-pointer" />
          </Modal.Header>

          <Modal.Body>
            <div className="modal-body">
              <ImgDropzone
                ref={childRef}
                onSubmit={handleImageUpload}
                acceptedFileExtenstion=".jpeg,.png,.jpg"
                image={imgsrc()}
                isEditMode={!isNewUploaded}
                fromColour={croppedImage?.includes('data:image/png;base64')}
                title={t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.TESTING')}
              />
            </div>
          </Modal.Body>
        </Modal>
      ) : (
        <>
          <div className="page-title-filter sticky">
            <div className="title-container">
              <h4 className="title">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.TESTING_GROUP')}</h4>
            </div>
            <div className="search-filter">
              {btns()}
              {backOrCancle()}
            </div>
          </div>
          <div className="container-fluid py-4">
            <Row>
              <Col lg="2">
                <div className="image-container">
                  <div className="d-flex align-items-center">
                    <div className="img">
                      <img width="88" alt="croppedImage" src={imageSource()} />
                    </div>
                    <div className="d-flex flex-column justify-content-between ">{buttons()}</div>
                  </div>
                </div>
              </Col>
              <Col lg="3">
                <FormGroup>
                  <div className="input-group form-floating-label fixed-label">
                    <input
                      type="text"
                      label="groupName"
                      name="groupName"
                      {...register('groupName', { required: true })}
                      placeholder={t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.NAME_GROUP')}
                      disabled={paramId && !allowEdit}
                      // onChange={handleGroupName}
                      className="form-control"
                    />
                    <label className="asterisk-req">
                      {t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.GROUP_NAME')}
                      <span>*</span>
                    </label>
                  </div>

                  {errors.groupName && <span className="error-message">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.GROUP_NAME_REQUIRED')} </span>}
                </FormGroup>
              </Col>
              <Col lg="7">
                <FormGroup>
                  <div className="input-group form-floating-label fixed-label">
                    <input
                      type="text"
                      label="groupDescription"
                      name="groupDescription"
                      // onChange={handleGroupDescription}
                      {...register('groupDescription', { required: true })}
                      disabled={paramId && !allowEdit}
                      placeholder={t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.GROUP_DESCRIPTION')}
                      className="form-control"
                    />
                    <label className="asterisk-req">
                      {t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.GROUP_DESCRIPTION')}
                      <span>*</span>
                    </label>
                  </div>
                  {errors.groupDescription && <span className="error-message">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.GROUP_DES_REQ')} </span>}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <div className="col-lg-6 d-flex w-100 mt-3 mb-3">
                <AsyncTypeahead
                  id="typeheadWithColours"
                  className="custom-AsyncTypeHead"
                  isLoading={suggestionLoader}
                  // labelKey="code"
                  labelKey={(option) =>
                    `${option?.code}${openBracket(option)}${openSupps(option)}${openBom(option)}${openCol(option)}${CloseBracket(option)}-${openDesc(option)}`
                  }
                  disabled={paramId && !allowEdit}
                  minLength={1}
                  onSearch={(query) => promiseSearch(query)}
                  options={allOptions}
                  ref={typeaheadConfig}
                  promptText="No Testing Library found"
                  placeholder={`${t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.SEARCH_TESTING')}`}
                  useCache={false}
                  onChange={(selected) => onAutoSuggestion(selected)}
                  renderMenuItemChildren={(option) => (
                    <div className="d-flex" key={option._id}>
                      <div className="list-text">
                        {option?.code
                          ? shortenStringWithTooltip(
                              `${option?.code}${openBracket(option)}${openSupps(option)}${openBom(option)}${openCol(option)}${CloseBracket(option)}-${openDesc(
                                option,
                              )}`,
                              40,
                            )
                          : ''}
                      </div>
                    </div>
                  )}
                />
                <div className="btn-outline-container">
                  <BtnDelete
                    multiDelete={() => {
                      handleDeleteCard(null);
                    }}
                    isDisabled={isEmpty(selectedIdArray) || (paramId && !allowEdit)}
                  />
                </div>
              </div>
            </Row>
            <div id="testingTableGroup" className="table-responsive" style={{ maxHeight: 'calc(100vh - 330px)' }}>
              <table className="table custom-table layout-fixed m-0" id="testingTableGroup">
                <thead>
                  <tr>
                    {!isSupplierLoggedIn && !isProductArchived && (
                      <th className="w-80px w-xs-40px">
                        <div className="checkbox-label no-label margin-auto">
                          <input
                            type="checkbox"
                            onChange={handleSelectAll}
                            name="check_all"
                            id="check_all"
                            checked={isSelectAll}
                            disabled={isEmpty(colourRefDatatoShow) || (paramId && !allowEdit)}
                          />
                          <label htmlFor="check_all" className="chklabel">
                            <span />
                          </label>
                        </div>
                      </th>
                    )}
                    <th className="w-150px w-xs-130px last-fix-col">
                      <span className="cursor-pointer">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.TESTING_CODE')}</span>
                    </th>
                    <th className="w-300px w-xs-130px">
                      <span className="cursor-pointer">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.DESCRIPTION')}</span>
                    </th>
                    <th className="w-200px w-xs-130px">
                      <span className="cursor-pointer">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.TEST_TYPE')}</span>
                    </th>
                    <th className="w-120px">
                      <span className="cursor-pointer">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.MINIMUM_PASS_RATE')}</span>
                    </th>
                    <th className="w-250px w-xs-130px">
                      <span className="cursor-pointer">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.TESTING_REPORT')}</span>
                    </th>
                    <th className="w-200px">
                      <span className="cursor-pointer">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.SUPPLIER')}</span>
                    </th>
                    <th className="w-200px w-xs-130px">
                      <span className="cursor-pointer">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.BOM_COMPONENTS')}</span>
                    </th>
                    <th className="w-200px w-xs-130px">
                      <span className="cursor-pointer">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.COLOUR_REF')}</span>
                    </th>
                    <th className="w-300px w-xs-130px">
                      <span className="cursor-pointer">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.ADDITIONAL_INFO')}</span>
                    </th>
                    <th className="w-100px">
                      <span className="cursor-pointer">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.TEST_PRICE')}</span>
                    </th>
                    <th className="w-100px col-id-no">{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.ACTION')}</th>
                  </tr>
                </thead>
                <tbody>
                  {!isEmpty(colourRefDatatoShow) &&
                    colourRefDatatoShow.map((colourRefEle, colourRefIndex) => {
                      return handleTable(colourRefEle, colourRefIndex);
                    })}
                  {isEmpty(colourRefDatatoShow) && (
                    <td className=" text-center" colSpan="100%">
                      <h6>{t('TESTINGS.TESTING_GROUP.ADD_EDIT_TESTING_GROUP.NO_RECORDS_FOUND')}</h6>
                    </td>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default AddEditTestingGroup;
